// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gUtko","footer":"styles_footer__3i_fi","passCodeTooltip":"styles_passCodeTooltip__1iai6"};